import React, { useEffect, useState } from "react";
import constant from "../../../utils/constant";
import { PaymentLinkController } from "../../../controllers";
import { MimaToastUtil } from "../../../components";
import { object, string, number, boolean } from "yup";
import { paymentLinkStore } from "../../../stores";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import { phoneRegExp } from "../../../utils/utils";

const usePaymentLinkCheckoutLogic = () => {
  const [loading, setLoading] = useState(true);
  const [showCharge, setshowCharge] = useState(false);
  const [paystackCharge, setPaystackCharge] = useState(0);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getPaymentLinkDetails = async () => {
      setLoading(true);

      const { errorMessage } =
        await PaymentLinkController.getPaymentCheckoutDetails(id);
      if (errorMessage) {
        setLoading(false);
        setshowCharge(false);
        return MimaToastUtil.error(errorMessage);
      }
      setLoading(false);
      setshowCharge(false);

      if (
        !paymentCheckoutDetails.acceptPartPayment &&
        paymentCheckoutDetails.amount > 0 &&
        !paymentCheckoutDetails.acceptQuantity
      ) {
        let values = {
          amount: paymentCheckoutDetails.amount,
          quantity: 1,
        };

        getExactCharge(values);
      }
    };
    getPaymentLinkDetails();
  }, []);

  const paymentCheckoutDetails = paymentLinkStore.paymentCheckoutDetails;
  const charges = paymentLinkStore.charges;

  const validationSchema = () => {
    return object({
      amount: number()
        .when("acceptPartPayment", {
          is: true,
          then: number().min(yup.ref("minDeposit"), ({ min }) => {
            return `Amount cannot be less than ${min}`;
          }),
          otherwise: number().when("totalAmount", {
            is: (totalAmount) => totalAmount > 0,
            then: number().min(yup.ref("totalAmount"), ({ min }) => {
              return `Amount cannot be less than ${min}`;
            }),
          }),
        })
        .required("Amount is required"),
      fullname: string()
        .required("Enter your Full name")
        .test("fullname", "First and Last name is required", function (value) {
          const names = value ? value.split(" ") : [];
          return names.length > 1 && names[0].length > 1 && names[1].length > 1;
        }),
      email: string()
        .trim()
        .email("Enter a valid Email")
        .required("Email Address is required"),
      quantity: yup.number().when("acceptQuantity", {
        is: true,
        then: (schema) =>
          schema.min(1, "Minimum should be 1").required("Quantity is required"),
        otherwise: (schema) => schema.optional(),
      }),
      mobile: yup.string().when("acceptPhoneNumber", {
        is: true,
        then: (schema) =>
          schema
            .matches(phoneRegExp, "Phone number is not valid")
            .required("phone number is required"),
        otherwise: (schema) => schema.optional(),
      }),
      instagramHandle: yup.string().when("acceptInstagramHandle", {
        is: true,
        then: (schema) => schema.required("Instagram Handle is required"),
        otherwise: (schema) => schema.optional(),
      }),
      address: yup.string().when("acceptAddress", {
        is: true,
        then: (schema) => schema.required("Address is required"),
        otherwise: (schema) => schema.optional(),
      }),
      // mobile: string().required('Phone number is required'),
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);
    let payload = {};

    delete values.acceptQuantity;
    delete values.acceptInstagramHandle;
    delete values.acceptPhoneNumber;
    delete values.acceptAddress;
    delete values.minDeposit;

    const payWith = values.payWith;
    payload = {
      ...values,
      amount: values.amount * values.quantity,
    };

    payload.paymentLinkId = paymentCheckoutDetails._id;
    delete payload.payWith;

    if (payload.mobile === "") {
      delete payload.mobile;
    }
    if (payload.address === "") {
      delete payload.address;
    }

    const { status, errorMessage, data } =
      await PaymentLinkController.createPaymentLinkInvoice(payload);

    if (status === constant.Success) {
      MimaToastUtil.success({
        message: "Navigating to Payment Page",
      });
      const invoice = data;
      if (invoice.currencyCode === "NGN" && payWith === "TRANSFER") {
        navigate(`/mima-checkout?invoiceId=${invoice._id}`);
      } else if (invoice.currencyCode === "NGN" && payWith === "CARD") {
        window.open(invoice.paymentUrl, "_self");
      } else {
        window.open(invoice.paymentUrl, "_self");
      }
      setshowCharge(false);
      setLoading(false);
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };

  const getExactCharge = async (values) => {
    let payload;

    payload = {
      amount: values.amount,
      quantity: values.quantity,
      chargeSplit: paymentCheckoutDetails.chargeSplit,
    };

    const getPaystackCharge =
      (1.5 / 100) * (payload.amount * payload.quantity) + 100;

    if (payload.chargeSplit === "MY BUSINESS") {
      setPaystackCharge(0);
    } else if (
      payload.chargeSplit === "EQUAL SPLIT" &&
      getPaystackCharge > 2000
    ) {
      setPaystackCharge(1000);
    } else if (payload.chargeSplit === "EQUAL SPLIT") {
      setPaystackCharge(getPaystackCharge / 2);
    } else if (getPaystackCharge > 2000) {
      setPaystackCharge(2000);
    } else {
      setPaystackCharge(getPaystackCharge);
    }

    if (paymentCheckoutDetails.currencyCode === "NGN") {
      payload.name = "NGN PAYMENT COLLECTION CHARGE";
    }

    if (paymentCheckoutDetails.currencyCode === "USD") {
      payload.name = "USD PAYMENT COLLECTION CHARGE";
    }

    if (paymentCheckoutDetails.currencyCode === "GBP") {
      payload.name = "GBP PAYMENT COLLECTION CHARGE";

      if (paymentCheckoutDetails.currencyCode === "NGN") {
        payload.name = "NGN PAYMENT COLLECTION CHARGE";
      }
    }

    if (paymentCheckoutDetails.currencyCode === "EUR") {
      payload.name = "EUR PAYMENT COLLECTION CHARGE";
    }

    const { status, errorMessage, data } =
      await PaymentLinkController.getCharges(payload);

    if (status === constant.Success) {
      setshowCharge(true);
    } else {
      setshowCharge(false);
    }
  };
  return {
    paymentCheckoutDetails,
    validationSchema,
    onSubmit,
    loading,
    getExactCharge,
    charges,
    showCharge,
    setshowCharge,
    paystackCharge,
  };
};

export default usePaymentLinkCheckoutLogic;
